import { restApi } from '../../services/api';
import { CreatePosBody } from './pos.types';

const posRepository = {
  createPos: (data: CreatePosBody) => restApi.post<void>('store-points-of-sale', data),
};

export default posRepository;
